import { HttpClient } from "../common/http-client";
import { Environment } from "../environment/app-settings";
import {
  RequestKontomatikSignInRedirectionStart,
  RequestKontomatikSignInRedirectionStartResponse,
  RequestKontomatikSignInRedirectionStatusResponse,
  RequestKontomatikSetSession,
  RequestKontomatikSetSessionResponse
} from "../models/request.url.dto";
import analyticsService from "./analytics.service";

export class KontomatikService {
  private readonly _client: HttpClient;
  private readonly _url = "kontomatik";
  private readonly _signinRedirectionUrl = "kontomatik/signin-redirection";
  constructor() {
    this._client = new HttpClient(Environment.apiUrl);
  }

  public async setSessionData(dto: RequestKontomatikSetSession): Promise<RequestKontomatikSetSessionResponse> {
    const url = `${this._url}/session`;
    return (await this._client.post<RequestKontomatikSetSessionResponse, RequestKontomatikSetSession>(url, dto, true)).data;
  }

  public async startSignInRedirection(dto: RequestKontomatikSignInRedirectionStart): Promise<RequestKontomatikSignInRedirectionStartResponse> {
    const url = `${this._signinRedirectionUrl}/start`;


    return (await this._client.post<RequestKontomatikSignInRedirectionStartResponse, RequestKontomatikSignInRedirectionStart>(url, dto, true)).data;
  }

  public async getSignInRedirectionStatus(redirectionId: string): Promise<RequestKontomatikSignInRedirectionStatusResponse> {
    const url = `${this._signinRedirectionUrl}/status/${encodeURIComponent(redirectionId)}`;
    return (await this._client.get<RequestKontomatikSignInRedirectionStatusResponse>(url, true)).data;
  }
}